import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./ImageSwiper.scss";

// import required modules
import { Fancybox } from "@fancyapps/ui";
import { useTranslation } from "react-i18next";
import { Navigation, Pagination } from "swiper/modules";
import { UI } from "../../config/ui";
import { replaceUrlCdn } from "../../utils/common";
import NetworkMediaFile from "../image/NetworkMediaFile";
import { icAsset } from "../image/image-src";

interface ImageSwiperProps {
  images: string[];
  isHideSwiper?: boolean;
  cdnParams?: CdnParam;
}

const ImageSwiper: React.FC<ImageSwiperProps> = ({
  images,
  isHideSwiper,
  cdnParams,
}) => {
  // images.length = 1;
  // images.length = 2;
  // images.length = 3;
  const { t } = useTranslation();

  const openFullScreen = () => {
    // setIsFullScreen(true);
    if (images.length === 0) return;
    // Wrap in requestAnimationFrame to prevent ResizeObserver loop warning
    requestAnimationFrame(() => {
      Fancybox.show(
        images.map((src) => ({
          src: replaceUrlCdn(src),
          type: "image",
        })),
        {
          Thumbs: false,
          Toolbar: false,
          closeButton: "auto",
          hideScrollbar: true,
        },
      );
    });
  };
  const len = images?.length;

  return (
    <div className="relative max-h-[235px] overflow-hidden sm:mx-5 sm:max-h-[unset] sm:min-h-[unset] sm:rounded-[1.25rem]">
      {!!len && (
        <>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={16}
            breakpoints={{
              [UI.sm]: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
            }}
            centeredSlides={true}
            loop={true}
            // navigation={{
            //   nextEl: ".swiper-button-next",
            //   prevEl: ".swiper-button-prev",
            // }}
            modules={[Pagination, Navigation]}
            pagination={{
              el: ".swiper-pagination",
              // type: "fraction",
              // renderFraction: (currentClass: string, totalClass: string) => {
              //   return `<div><span class="${currentClass}"></span> / <span class="${totalClass}"></span></div>`;
              // },
              type: "custom",
              renderCustom: (swiper: any, current: number, total: number) => {
                if (len === 2 || len === 3) {
                  current = current % len;
                  if (!current) {
                    current = len;
                  }
                  total = total / 2;
                }

                // return current + " of " + total;
                return `<div><span class="swiper-pagination-current">${current}</span> / <span class="swiper-pagination-total">${total}</span></div>`;
              },
            }}
            className="product-swiper !overflow-visible"
          >
            {images.map((src, index) => (
              <SwiperSlide key={index}>
                <NetworkMediaFile
                  className="!aspect-[944/480] h-[235px] max-h-[235px] max-w-[100vw] sm:h-full sm:max-h-[unset] sm:max-w-[unset]"
                  file={{ src }}
                  cdnParams={cdnParams}
                  loading={index < 3 ? "eager" : "lazy"}
                  fetchPriority={index < 3 ? "high" : "low"}
                />
              </SwiperSlide>
            ))}

            {(len === 2 || len === 3) &&
              images.map((src, index) => (
                <SwiperSlide key={index}>
                  <NetworkMediaFile
                    className="!aspect-[944/480] h-[235px] max-h-[235px] max-w-[100vw] sm:h-full sm:max-h-[unset] sm:max-w-[unset]"
                    file={{ src }}
                    cdnParams={cdnParams}
                    loading={index < 3 ? "eager" : "lazy"}
                    fetchPriority={index < 3 ? "high" : "low"}
                  />
                </SwiperSlide>
              ))}

            <div className="swiper-pagination"></div>
          </Swiper>
          <button className="all-photos-btn" onClick={openFullScreen}>
            <img src={icAsset("../../../assets/icons/menu.svg")} alt="" />
            <span>{t("All photos")}</span>
          </button>
        </>
      )}
    </div>
  );
};
export default ImageSwiper;
